import { render, staticRenderFns } from "./IndexFloorAds.vue?vue&type=template&id=70475fcc&scoped=true"
import script from "./IndexFloorAds.vue?vue&type=script&lang=js"
export * from "./IndexFloorAds.vue?vue&type=script&lang=js"
import style0 from "./IndexFloorAds.vue?vue&type=style&index=0&id=70475fcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70475fcc",
  null
  
)

export default component.exports